import { mergeStyleSets } from '@uifabric/merge-styles';

export default mergeStyleSets({
  entryContainer: {
    display: 'flex',
    width: '100%',
    marginBottom: 10,
  },
  transactionField: {
    width: '50%',
  },
  buttonContainer: {
    marginLeft: '5px',
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'flex-end',
  },
});
